const PS = require("./util/ParserState");
const Helpers = require("./util/ParserHelpers");

const parseTable = function(ps, tableSpecPs, parseCellContents, extraOptions) {
	const {read} = extraOptions || {};
	ps = PS.convert(ps);
	tableSpecPs = PS.convert(tableSpecPs);

	//dealing with the table spec
	const tableInfo = parseTableSpec(tableSpecPs);
	if (!tableInfo) {
		return false;
	}

	//finding the actual contents of the table
	const tableRowPs = Helpers.splitByDelimIntoPs(ps, {begin: "\\\\"});
	const tableRowNodes = tableRowPs.map(function(rowPs, i) {
		// Allow optional argument to \\, giving extra vertical space as a
		// coefficient on font size. TODO: test and document.
		const extraYSpace = i > 0 ? Helpers.findOptionalArgument(rowPs) : false;
		const row = parseTableRow(
			rowPs,
			tableInfo,
			parseCellContents,
			extraOptions
		);
		row.extraYSpace = 0;
		if (row && extraYSpace) {
			row.extraYSpace = parseFloat(extraYSpace.text, 10) || 0;
		}
		return row !== false
			? row
			: {
					type: "error",
					name: "\\begin{tabular} row",
			  };
	});
	if (tableRowNodes[0]) {
		tableRowNodes[0].firstRow = true;
	}

	return [
		{
			type: "table",
			children: tableRowNodes,
			tableInfo: tableInfo,
			extraOptions: extraOptions || {},
			read,
		},
	];
};

// Given a parser state containing the table spec of a tabular (like 'r|cc'),
// return an object with keys columnAlignment and verticalLines.
const parseTableSpec = function(ps) {
	const tableSpec = ps.getRest();
	const columnAlignment = [];
	const lineInformation = [];
	let currColumn = 0;
	let currChar;
	for (let j = 0; j < tableSpec.length; j++) {
		currChar = tableSpec.charAt(j);
		if (/\s/.test(currChar)) {
			continue;
		}
		if (currChar === "|") {
			lineInformation[currColumn] = lineInformation[currColumn]
				? lineInformation[currColumn] + 1
				: 1;
		} else if (currChar === "l" || currChar === "c" || currChar === "r") {
			columnAlignment[currColumn] = currChar;
			if (!lineInformation[currColumn]) {
				lineInformation[currColumn] = 0;
			}
			currColumn++;
		} else {
			ps.pushError("Unrecognized tablespec character " + currChar, j);
			return false;
		}
	}

	return {
		columnAlignment: columnAlignment,
		verticalLines: lineInformation,
	};
};

// Given a parser state containing a row of a tabular, return a tableRow node
// with the results of parsing the row. tableInfo should be the return of
// parseTableSpec, and parseCellContents should be a function taking a parser
// state which gets applied to each cell of the table.
const parseTableRow = function(ps, tableInfo, parseCellContents, extraOptions) {
	const {read} = extraOptions;

	//dealing with hlines and clines at the beginning of the line
	const horizontalLines = [];
	let match;
	let clineResult;
	while (!ps.done()) {
		if ((match = /^\s*\\hline/.exec(ps.getRest()))) {
			// Handle \hline.
			ps.pos += match[0].length;
			const widthMultiplier = Helpers.findOptionalArgument(ps);
			horizontalLines.push({
				type: "h",
				widthMultiplier: widthMultiplier ? parseInt(widthMultiplier.text) : 1,
			});
		} else if ((match = /^\s*\\cline/.exec(ps.getRest()))) {
			// Handle \cline.
			ps.pos += match[0].length;
			clineResult = parseCline(ps);
			const widthMultiplier = Helpers.findOptionalArgument(ps);
			if (clineResult) {
				clineResult.widthMultiplier = widthMultiplier
					? parseInt(widthMultiplier.text)
					: 1;
				horizontalLines.push(clineResult);
			}
		} else {
			// No hline or cline; stop looking.
			break;
		}
	}

	if (!ps.getRest().trim()) {
		return {
			type: "tableRow",
			children: [],
			tableInfo: tableInfo,
			horizontalLines: horizontalLines,
			extraOptions,
			read,
		};
	}

	// Parsing cell contents.
	const origPos = ps.pos;
	const cellPs = Helpers.splitByDelimIntoPs(ps, {
		begin: "&",
		escape: "\\",
	});
	const cellNodes = cellPs.map(parseCellContents);

	if (cellNodes.length > tableInfo.columnAlignment.length) {
		ps.pushError(
			"Table row has " +
				cellNodes.length +
				" columns, " +
				"but tablespec had only " +
				tableInfo.columnAlignment.length +
				" columns.",
			origPos
		);
		return {
			type: "error",
			name: "table row",
		};
	}

	return {
		type: "tableRow",
		children: cellNodes,
		tableInfo: tableInfo,
		horizontalLines: horizontalLines,
		extraOptions,
		read,
	};
};

// Given a parser state right after a \cline command, parse the argument after
// it and return an object with type: "c", start, end. Returns false with an
// error in the parser state if the argument is invalid.
const parseCline = function(ps) {
	const argStartPos = ps.pos + 1;
	const args = Helpers.findArguments(ps, 1, {requireBrace: true});
	if (!args) {
		return false;
	}

	const argText = args[0].getRest();
	const clineRegex = /^\d+-\d+$/;
	if (!clineRegex.test(argText)) {
		ps.pushError(
			"Invalid cline argument format; should be '#-#'.",
			argStartPos
		);
		return false;
	}

	const argParts = argText.split("-");
	return {
		type: "c",
		start: parseInt(argParts[0]),
		end: parseInt(argParts[1]),
	};
};

module.exports = {
	parseTable: parseTable,
};
